export default __webpack_public_path__ + "static/media/nft-18.1a9ace2f.png";